import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  TextField, IconButton, Box, Tab, Paper, Typography,
  Drawer, List, ListItem, ListItemButton, ListItemIcon,
  ListItemText, Divider
} from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { es } from 'date-fns/locale'
import { useLocation } from 'react-router-dom'

import HojaAtencion from '../componentsV2/HojaAtencion'
import Defendido from '../componentsV2/Defendido'
import Servicios from '../componentsV2/Servicios'
import Causas from '../componentsV2/Causas'
import Cuotas from '../componentsV2/Cuotas'
import Pagador from '../componentsV2/Pagador'
import Contrato from '../componentsV2/Contrato'
import Validacion from '../componentsV2/Validacion'
import ContratoActualizacion from '../componentsV2/ContratoActualizacion'
import { setCargaDatos } from '../Redux/V2/ContratoRedux'

import { CircleX } from 'lucide-react'
import DifferenceIcon from '@mui/icons-material/Difference';
import FastRewindIcon from '@mui/icons-material/FastRewind';

import Cancelar from '../componentsV2/Acciones/Cancelar'
import Finiquitar from '../componentsV2/Acciones/Finiquitar';

import Cookies from 'universal-cookie'

const ContratoPage = ({ start }) => {

  const cookies = new Cookies();
  const dispatch = useDispatch()
  const location = useLocation()

  const [customerInterviewId, setCustomerInterviewId] = useState(null)
  // Lee desde el mismo slice de Cancelar.jsx
  const entrevista = useSelector((store) => store.contratoV2.Entrevista);
  const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);
  const contratoValidado = useSelector((store) => store.contratoV2.ContratoValidado);
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion);

  // Flag para desactivar el submenú "Cancelar"
  const [cancelDisabled, setCancelDisabled] = useState(false);
  // (opcional) razón para tooltip/log
  const [cancelReason, setCancelReason] = useState('');

  // === Nuevo: flag para desactivar el submenú "Finiquitar"
  const [finiqDisabled, setFiniqDisabled] = useState(false);
  // (opcional) razón/tooltip para finiquitar
  const [finiqReason, setFiniqReason] = useState('');

  // === Nuevo: flags para “Actualizar” y “Cambio de estrategia”
  const [updateDisabled, setUpdateDisabled] = useState(false);
  const [updateReason, setUpdateReason] = useState('');
  const [strategyDisabled, setStrategyDisabled] = useState(false);
  const [strategyReason, setStrategyReason] = useState('');

  const [showAcciones, setShowAcciones] = useState(false);
  const [accionesVisible, setAccionesVisible] = useState({
    cancelar: false,
    finiquitar: false, // lo dejo previsto por si lo usas luego
  });

  useEffect(() => {
    if (entrevista?.contractId)
      dispatch(setCargaDatos("Actualizacion", "get", entrevista.contractId))
  }, [entrevista?.contractId])

  useEffect(() => {
    //alert(JSON.stringify(actualizacion)) 
    if (actualizacion?.actualizacion == undefined)
      return
    if (entrevista?.etapaId && actualizacion?.actualizacion?.status != 1) {

      setActiveTab(entrevista.etapaId)
    }
    else if (actualizacion?.actualizacion?.status == 1) {
      setTabs((prevTabs) =>
        prevTabs.map((tab) => ({
          ...tab,
          active: tab.value === "actualizacion"
        }))
      );
    }
  }, [entrevista?.etapaId, actualizacion?.actualizacion?.status])

  useEffect(() => {
    console.log(actualizacion)
  }, [actualizacion])


  const setActiveTab = (tabValue) => {
    setTabs((prev) =>
      prev.map((item) => ({ ...item, active: item.value === tabValue }))
    )
  }

  const etapaMaximaPermitida = entrevista?.etapaId || 0;

  // === ID unificado de entrevista: prioriza location.state -> sessionStorage -> store (y lo convierte a número)
  const interviewId = useMemo(() => {
    const fromState = location.state?.customerInterviewId;
    const fromSession = sessionStorage.getItem('customerInterviewId');
    const fromStore = entrevista?.id;

    const raw = fromState ?? fromSession ?? fromStore ?? null;
    const asNumber = raw != null ? Number(raw) : null;

    return Number.isFinite(asNumber) ? asNumber : null;
  }, [location.state?.customerInterviewId, entrevista?.id]);

  const toggleDrawer = (open) => (event) => {
    if (event?.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setShowAcciones(open);
  };

  const onclickAcciones = (accion) => () => {
    console.log("Acción seleccionada:", accion);
    switch (accion) {
      case "Actualizar":
        var payload = {
          ContractId: entrevista.contractId,
          Type: 1 // 1= actualizacion
        }
        dispatch(setCargaDatos("Actualizacion", "post", payload))
        break;
      case "CambioEstrategia":
        var payload = {
          ContractId: entrevista.contractId,
          Type: 2 // 2= CAMBIO ESTRATEGIA
        }
        dispatch(setCargaDatos("Actualizacion", "post", payload))
        break;
      case "cancelar":
        setAccionesVisible((prev) => ({ ...prev, cancelar: true }));
        break;
      case "finiquitar":
        setAccionesVisible((prev) => ({ ...prev, finiquitar: true }));
        break;
    }
    // Deja que React procese el setState anterior y luego cierra el Drawer
    setTimeout(() => setShowAcciones(false), 0);
  };


  const ocultarAcciones = () => {
    setAccionesVisible({ cancelar: false, finiquitar: false });
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" /*onClick={toggleDrawer(false)}*/>
      <Typography variant="h6" sx={{ p: 2 }}>Acciones</Typography>
      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={onclickAcciones('cancelar')}
            disabled={cancelDisabled || actualizacion?.actualizacion?.status == 1}
            title={cancelDisabled && cancelReason ? cancelReason : undefined}
          >
            <ListItemIcon><CircleX /></ListItemIcon>
            <ListItemText primary="Cancelar" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton
            onClick={onclickAcciones("finiquitar")}
            disabled={finiqDisabled || actualizacion?.actualizacion?.status == 1}// ✅ antes estaba comentado
            title={finiqDisabled && finiqReason ? finiqReason : undefined}
          >
            <ListItemIcon><CircleX /></ListItemIcon>
            <ListItemText primary="Finiquitar" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            disabled={updateDisabled || actualizacion?.actualizacion?.status == 1}// ✅ usa regla nueva
            onClick={onclickAcciones("Actualizar")}
            title={updateDisabled && updateReason ? updateReason : undefined}
          >
            <ListItemIcon><DifferenceIcon /></ListItemIcon>
            <ListItemText primary="Actualizar" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton
            disabled={strategyDisabled || actualizacion?.actualizacion?.status == 1}// ✅ usa regla nueva
            onClick={onclickAcciones("CambioEstrategia")}
            title={strategyDisabled && strategyReason ? strategyReason : undefined}
          >
            <ListItemIcon><FastRewindIcon /></ListItemIcon>
            <ListItemText primary="Cambio Estrategia" />
          </ListItemButton>
        </ListItem>

      </List>
    </Box>
  );


  // 🔹 Al montar, si hay customerInterviewId en sessionStorage, hago GET de la entrevista
  useEffect(() => {
    const customerInterviewId = sessionStorage.getItem("customerInterviewId")

    if (customerInterviewId) {
      const fetchEntrevista = async () => {
        try {
          const exito = await dispatch(setCargaDatos("Entrevista", "get", customerInterviewId))
          if (!exito) {
            console.warn("No se pudo cargar la entrevista")
          }
        } catch (err) {
          console.error("Error cargando entrevista:", err)
        }
      }
      fetchEntrevista()
    }
  }, [dispatch])

  // Recuperar el id desde location.state o sessionStorage
  useEffect(() => {
    if (location.state?.customerInterviewId) {
      setCustomerInterviewId(location.state.customerInterviewId)
      sessionStorage.setItem('customerInterviewId', location.state.customerInterviewId)
    } else {
      const storedId = sessionStorage.getItem('customerInterviewId')
      if (storedId) setCustomerInterviewId(storedId)
    }
  }, [location.state])

  // === Persistimos el interviewId unificado en sessionStorage (por si entran por otra vía)
  useEffect(() => {
    if (interviewId != null) {
      sessionStorage.setItem('customerInterviewId', String(interviewId));
    }
  }, [interviewId]);

  // === Carga de estado de cancelación, finiquito y firmado usando interviewId (numérico)
  useEffect(() => {
    if (interviewId == null) return;
    dispatch(setCargaDatos("Defendido", "get", interviewId))
    dispatch(setCargaDatos('ContratoCancelado', 'get', interviewId));
    dispatch(setCargaDatos('ContratoFiniquitado', 'get', interviewId));
    dispatch(setCargaDatos('ContratoFirmado', 'get', interviewId));
    dispatch(setCargaDatos('ContratoValidado', 'get', interviewId));
  }, [interviewId]);

  // --- Derivar deshabilitados para Cancelar, Finiquitar, Actualizar y Cambio de Estrategia según cancelado/finiquitado/firmado/actualización
  useEffect(() => {
    const isCancelado = contratoCancelado?.cancelado === true || contratoCancelado?.cancelado === 'true';

    const isFiniquitado = contratoFiniquitado?.finiquitado === true || contratoFiniquitado?.finiquitado === 'true';

    const isFirmado = contratoFirmado?.firmado === true || contratoFirmado?.firmado === 'true';
    const isPendiente = contratoFirmado?.pendiente > 0 ? true : false;

    // 🔒 Si está finiquitado: TODO deshabilitado
    if (isFiniquitado) {
      setCancelDisabled(true); setCancelReason('Contrato finiquitado');
      setFiniqDisabled(true); setFiniqReason('Contrato finiquitado');
      setUpdateDisabled(true); setUpdateReason('Contrato finiquitado');
      setStrategyDisabled(true); setStrategyReason('Contrato finiquitado');
      return;
    }

    // Cancelar: deshabilitado si ya está cancelado o firmado
    const cancelDis = isCancelado || isFirmado; //|| isPendiente;
    console.log(isCancelado)
    console.log(isFirmado)
    setCancelDisabled(cancelDis);
    setCancelReason(cancelDis ? (isCancelado ? 'Contrato cancelado' : 'Contrato firmado') : '');

    // Finiquitar: requiere enviado o descagado y no cancelado
    //const finiqDis = !isPendiente || isFirmado || isCancelado;
    const finiqDis = !isFirmado || isCancelado;

    setFiniqDisabled(finiqDis);
    setFiniqReason(
      finiqDis
        ? (!isFirmado ? 'Debe estar firmado' : 'Contrato cancelado')
        : ''
    );

    // Actualizar / Cambio de estrategia:
    //  - deshabilitar si no está firmado, o está cancelado, o hay una actualización en curso
    const actEnCurso = actualizacion?.actualizacion?.status === 1;
    const updDis = !isFirmado || isCancelado || actEnCurso;
    const stratDis = !isFirmado || isCancelado || actEnCurso;
    setUpdateDisabled(updDis);
    setUpdateReason(
      updDis
        ? (!isFirmado ? 'Debe estar firmado' : isCancelado ? 'Contrato cancelado' : 'Actualización en curso')
        : ''
    );

    setStrategyDisabled(stratDis);
    setStrategyReason(
      stratDis
        ? (!isFirmado ? 'Debe estar firmado' : isCancelado ? 'Contrato cancelado' : 'Actualización en curso')
        : ''
    );

    /*if (actEnCurso) {
      setTabs((prevTabs) =>
        prevTabs.map((tab) => ({
          ...tab,
          active: tab.value === "actualizacion"
        }))
      );
    }*/

  }, [contratoCancelado, contratoFiniquitado, contratoFirmado, actualizacion?.actualizacion?.status]);


  /*useEffect(() => {
    switch (start) {
      case 0:
        // dispatch(setCargaDatos("entrevista", "get", customerInterviewId))
        break
      default:
        break
    }
  }, [start, customerInterviewId, dispatch])*/

  const handleChangeSave = (newValue) => {
    if (newValue < 8) newValue = newValue + 1
    setTabs((prev) =>
      prev.map((item) => ({ ...item, active: item.value === newValue }))
    )
  }

  // 👇 NUEVO: función que podrás usar desde hijos
  const goToTab = (value) => setActiveTab(value);

  const [tabs, setTabs] = useState([
    // { label: 'Hoja de Atencion', value: 1, active: true, renderView: <HojaAtencion from={1} onChangeSave={handleChangeSave} /> },
    { label: "Hoja de Atencion", value: 0, active: true, renderView: (<HojaAtencion from={0} onChangeSave={handleChangeSave} />) },
    { label: 'Defendido', value: 1, active: false, renderView: <Defendido from={1} onChangeSave={handleChangeSave} actualizacion={actualizacion} /> },
    { label: 'Servicios', value: 2, active: false, renderView: <Servicios from={2} onChangeSave={handleChangeSave} /> },
    { label: 'Cuotas', value: 3, active: false, renderView: <Cuotas from={3} onChangeSave={handleChangeSave} /> },
    { label: 'Contrato', value: 4, active: false, renderView: <Contrato from={4} onChangeSave={handleChangeSave} /> },
    { label: 'Validacion', value: 5, active: false, renderView: <Validacion from={5} onChangeSave={handleChangeSave} /> },
    { label: 'Contrato Actualización', value: "actualizacion", active: false, renderView: <ContratoActualizacion from={"actualizacion"} onChangeSave={handleChangeSave} /> },
    { label: 'Acciones', value: 'acciones', active: false, renderView: null } // 👈 agregado aquí
    //   { label: 'Causas', value: 4, active: false, renderView: <Causas from={4} onChangeSave={handleChangeSave} /> },  
    //   { label: 'Pagador', value: 6, active: false, renderView: <Pagador from={6} onChangeSave={handleChangeSave} /> }, 
  ])

  const handleChange = (event, newValue) => {
    setTabs((prev) =>
      prev.map((item) => ({ ...item, active: item.value === newValue }))
    )
  }



  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>

      <Paper elevation={1} className='bg-white' sx={{ minHeight: 'calc(100vh - 155px)', paddingTop: '5px' }}>
        <TabContext value={tabs.find((x) => x.active).value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
            {/* Tabs normales a la izquierda */}
            <TabList
              onChange={(e, newValue) => {
                if (newValue === 'acciones') return setShowAcciones(true)
                handleChange(e, newValue)
              }}
              sx={{ flex: 1 }}
            >
              {tabs.filter(t => t.value !== 'acciones').map((row, key) => (
                <Tab
                  hidden={actualizacion?.actualizacion?.status != 1 && row.value == "actualizacion"}
                  key={key}
                  label={row.label}
                  value={row.value}
                  // ✅ Evita deshabilitar la pestaña "Validacion" (5) cuando contratoFirmado?.firmado es true,
                  //    incluso si etapaMaximaPermitida < 5
                  disabled={(row.value > etapaMaximaPermitida) && !(contratoFirmado?.firmado && row.value === 5)}
                />
              ))}

            </TabList>

            {/* Tab Acciones a la derecha */}
            <TabList
              onChange={(e, newValue) => {
                if (newValue === 'acciones') setShowAcciones(true)
              }}
              sx={{ minWidth: 100 }}
            >
              <Tab label="Acciones" value="acciones" />
            </TabList>
          </Box>

          {tabs.map((row, key) => (
            <TabPanel key={key} value={row.value}>
              <Typography variant='h5' component='h5' className='mb-3'>
                {row.label}
              </Typography>
              {row.active ? row.renderView : 'no seleccionado'}
            </TabPanel>
          ))}
        </TabContext>
      </Paper>

      <Drawer anchor="right" open={showAcciones} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>

      {/* Dale un contenedor con zIndex para que no quede detrás del Drawer */}
      {accionesVisible.cancelar && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,                 // top:0, right:0, bottom:0, left:0
            overflow: 'auto',
            bgcolor: 'background.default',
            zIndex: (t) => t.zIndex.modal + 2, // por encima del Drawer y modales comunes
            p: { xs: 1, sm: 2, md: 3 },
          }}
        >
          <Cancelar setHide={ocultarAcciones} />
        </Box>
      )}
      {accionesVisible.finiquitar && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            overflow: 'auto',
            bgcolor: 'background.default',
            zIndex: (t) => t.zIndex.modal + 2,
            p: { xs: 1, sm: 2, md: 3 },
          }}
        >
          <Finiquitar setHide={ocultarAcciones} />
        </Box>
      )}
    </LocalizationProvider>
  )
}

export default ContratoPage
